import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import { createStyles, makeStyles } from "@material-ui/core";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import {
  Box,
  Button,
  createTheme,
  FormControl,
  Grid,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ChipCmp from "../../components/chip/chipCmp";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import Autocomplate from "../../components/dropdown/Autocomplate";
import DropdownCmp2 from "../../components/dropdown/DropdownCmp2";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import {
  CHEQUE_TYPE_STATUS_SETAD,
  LOAN_TEMPLATE_SETAD,
  SUPPLIERIDS,
  TABLE_FILTER_SUPP,
  TABLE_FILTER_SUPP_ROWNumber,
} from "../../config/cacheKey";
import { GetStatusResponse } from "../../models/basicInformation.model";
import { FilterFinder, PaginationInfo } from "../../models/cartable.model";
import {
  ChequesFilter,
  GetChequeInfoReportRequest,
  GetChequeInfoReportResponse,
} from "../../models/chequeInfoReport.model";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import {
  GetChequeTypeStatus,
  GetLoanTemplatesForSetad,
  GetSuppliers,
} from "../../services/basicInformation.service";
import {
  ExportChequeInfo,
  GetChequeInfoReport,
} from "../../services/chequeInfoReport.service";
import { convertToLocalDateTime } from "../../utility/dateUtility";
const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src='images/Next.png' />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src='images/Previous.png' />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const columns: readonly ColumnModel[] = [
  {
    id: "supplierTitle",
    label: "پذیرنده",
  },
  {
    id: "financialSupplierTitle",
    label: "منابع",
  },
  {
    id: "sayadNumber",
    label: "شماره صیادی",
  },
  {
    id: "chequeTypeTitle",
    label: "نوع چک",
  },
  {
    id: "dueDate",
    label: "تاریخ چک",
  },
  {
    id: "chequeAmount",
    label: "مبلغ چک (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  {
    id: "installmentType",
    label: "نحوه دریافت چک",
  },
  { id: "nationalCode", label: "کد ملی" },
  { id: "customerFullName", label: "متقاضی" },
  {
    id: "cellPhone",
    label: "شماره همراه",
  },
  {
    id: "loanStatus",
    label: "وضعیت تسهیلات",
  },
  {
    id: "finalAmount",
    label: "مبلغ تسهیلات (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  {
    id: "loanTemplateTitle",
    label: "طرح فروش",
  },
  {
    id: "postalCode",
    label: "کدپستی",
  },
  {
    id: "address",
    label: "آدرس",
  },
];

const ChequeInfo = () => {
  const queryClient = useQueryClient();
  const [valueFilterData, setValueFilterData] = useState<ChequesFilter>();
  const [data, setData] = useState<GetChequeInfoReportResponse[]>();
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );
  const [dueDate, setDueDate] = useState<Date[] | null | undefined>(null);
  const [valueDueDate, setValueDueDate] = useState<string>();
  const [supplierIdsOptions, setSupplierIdsOptions] = useState<
    GetStatusResponse[]
  >([]);
  const [chequeType, setchequeTypes] = useState<GetStatusResponse[]>();
  const [loanTemplateOptions, setLoanTemplateOptions] = useState<
    GetStatusResponse[]
  >([]);
  const [financialSupplierIds, setfinancialSupplierIds] = useState<
    GetStatusResponse[]
  >([]);
  const [valuecustomerFullName, setvaluecustomerFullName] = useState<string>();
  const [valueSayadNumber, setValueSayadNumber] = useState<string>();
  const [valueMultiSelect, setValueMultiSelect] = useState<any>();
  const [valueMulti, setValueMulti] = useState<string>();
  const [valueSupplierIds, setValueSupplierIds] = useState<number[]>([]);
  const [valueSupplier, setValueSupplier] = useState<any[]>([]);
  const [valueLoanTemplateOptions, setValueLoanTemplateOptions] = useState<
    number[]
  >([]);
  const [valuefinancialSupplierIds, setValuefinancialSupplierIds] = useState<
    number[]
  >([]);
  const [valueLoanTemplate, setValueLoanTemplate] = useState<any[]>([]);
  const [valuefinancialSupplier, setValuefinancialSupplier] = useState<any[]>(
    []
  );
  const [
    valueCustomerNationalCode,
    setValueCustomerNationalCode,
  ] = React.useState<string>();
  const [
    valueCustomerMobileNumber,
    setValueCustomerMobileNumber,
  ] = React.useState<string>();
  let row: any;
  const oldPage = queryClient.getQueryData<FilterFinder>(
    TABLE_FILTER_SUPP_ROWNumber
  );
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [valueRequestDate, setValueRequestDate] = React.useState<string>();

  React.useEffect(() => {
    let chequesFilter = {} as ChequesFilter;
    queryClient.setQueryData(TABLE_FILTER_SUPP, chequesFilter);
    if (history.action === "POP" && oldPage?.rowNumber != undefined) {
      row = queryClient.getQueryData(TABLE_FILTER_SUPP_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber == undefined
    ) {
      row = undefined;
      setSelectedRow(row);
    }
    if (history.action === "POP" && oldPage?.rowNumber == undefined) {
      row = undefined;
      setSelectedRow(row);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber != undefined
    ) {
      row = queryClient.getQueryData(TABLE_FILTER_SUPP_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    const previousPage =
      history.location.state !== undefined ? history.location.state.from : null;

    let filterData;

    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<ChequesFilter>(TABLE_FILTER_SUPP);
      if (filterData !== undefined && filterData !== null) {
        setValueMultiSelect(filterData!.chequeType!);

        setValueLoanTemplateOptions(filterData?.loanTemplateIds!);
        setValuefinancialSupplierIds(filterData?.financialSupplierIds!);
        setValueSupplierIds(filterData?.supplierIds!);
        setvaluecustomerFullName(filterData?.customerFullName!);
        setValueSayadNumber(filterData?.sayadNumber!);
        setValueCustomerNationalCode(filterData?.nationalCode!);
        setValueCustomerMobileNumber(filterData?.cellPhone!);
      }
    } else {
      filterData = {} as ChequesFilter;
      filterData.customerFullName = "";
      filterData.nationalCode = "";
      filterData.cellPhone = "";
      filterData.loanTemplateIds = [];
      filterData.financialSupplierIds = [];
      filterData.supplierIds = [];
      filterData.sayadNumber = "";
      queryClient.setQueryData(TABLE_FILTER_SUPP, filterData);
    }
    fillData(filterData!);
    const filterSupp = new FilterFinder();
    queryClient.setQueryData(TABLE_FILTER_SUPP_ROWNumber, filterSupp);
  }, []);
  const generateFilter = (
    filterData: ChequesFilter
  ): GetChequeInfoReportRequest => {
    let due = {} as GetChequeInfoReportRequest;
    due.paginationInfo = currentPaginationInfo;
    due.filter = filterData;
    return due;
  };
  const fillData = (filterData: ChequesFilter) => {
    let filter = generateFilter(filterData);

    GetChequeInfoReportMutate.mutate(filter);
    setValueFilterData(filter?.filter);
  };
  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
    loanRequestId: number;
    natinalCode: string;
  }>();
  useQuery<GetStatusResponse[]>(LOAN_TEMPLATE_SETAD, GetLoanTemplatesForSetad, {
    onSuccess(data) {
      setLoanTemplateOptions(data);
    },
  });
  useQuery<GetStatusResponse[]>(LOAN_TEMPLATE_SETAD, GetLoanTemplatesForSetad, {
    onSuccess(data) {
      setLoanTemplateOptions(data);
    },
  });
  useQuery<GetStatusResponse[]>(SUPPLIERIDS, GetSuppliers, {
    onSuccess(data) {
      setSupplierIdsOptions(data);
    },
  });
  const GetChequeInfoReportMutate = useMutation(GetChequeInfoReport, {
    onSuccess: (data: ApiResultModel<GetChequeInfoReportResponse[]>) => {
      if (data) {
        setData(data.data);
        let pageInfoModel = new PageInfoModel();
        pageInfoModel.pageNumber = 1;
        pageInfoModel.pageSize = 10;
        pageInfoModel.total = 0;
        setPageInfo(data.pageInfo !== null ? data.pageInfo : pageInfoModel);
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    GetChequeInfoReportMutate.mutate({
      paginationInfo: { pageNumber: 0, pageSize: 0 },
      filter: {},
    });
  }, []);
  let muiSelected: any;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const ExportChequeInfoMutation = useMutation(ExportChequeInfo, {
    onSuccess: (result) => {},
    onError: (e) => {},
  });
  useQuery<GetStatusResponse[]>(CHEQUE_TYPE_STATUS_SETAD, GetChequeTypeStatus, {
    onSuccess(data) {
      setchequeTypes(data);
    },
  });
  function setChildValueStat(childValues: any) {
    const selectedItem = "";
    setValueMultiSelect(undefined);
    setValueMulti(undefined);

    const tabelFilter = queryClient.getQueryData<ChequesFilter>(
      TABLE_FILTER_SUPP
    );
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.chequeType = undefined;
    fillData(tabelFilter!);
  }
  const setChildValueSupplierIds = (childValues: any) => {
    const selectedItem = valueSupplierIds.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueSupplier.filter(
      (item: any) => item.id != childValues
    );
    setValueSupplierIds(selectedItem);
    setValueSupplier(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<ChequesFilter>(
      TABLE_FILTER_SUPP
    );
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.supplierIds = tabelFilter!.supplierIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }

    fillData(tabelFilter!);
  };
  const setChildValueRequestDate = (childValues: any) => {
    const selectedItem = "";

    setValueDueDate(selectedItem);
    //    setRequestDateFrom(undefined);
    setDueDate(undefined);
    const tabelFilter = queryClient.getQueryData<ChequesFilter>(
      TABLE_FILTER_SUPP
    );
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.dueDateFrom = undefined;
      tabelFilter!.dueDateTo = undefined;
    }
    fillData(tabelFilter!);
  };
  const setChildValueLoanTemplate = (childValues: any) => {
    const selectedItem = valueLoanTemplateOptions.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueLoanTemplate.filter(
      (item: any) => item.id != childValues
    );
    setValueLoanTemplateOptions(selectedItem);
    setValueLoanTemplate(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<ChequesFilter>(
      TABLE_FILTER_SUPP
    );
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.loanTemplateIds = tabelFilter!.loanTemplateIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
      tabelFilter!.loanTemplateIds = tabelFilter!.loanTemplateIds
        ?.filter((item: any) => item.id != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValuefinancialSupplier = (childValues: any) => {
    const selectedItem = valuefinancialSupplierIds.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valuefinancialSupplier.filter(
      (item: any) => item.id != childValues
    );
    setValuefinancialSupplierIds(selectedItem);
    setValuefinancialSupplier(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<ChequesFilter>(
      TABLE_FILTER_SUPP
    );
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.financialSupplierIds = tabelFilter!.financialSupplierIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
      tabelFilter!.financialSupplierIds = tabelFilter!.financialSupplierIds
        ?.filter((item: any) => item.id != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueCustomerFullName = (childValues: any) => {
    const selectedItem = "";
    setvaluecustomerFullName(selectedItem);
    const tabelFilter = queryClient.getQueryData<ChequesFilter>(
      TABLE_FILTER_SUPP
    );
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerFullName = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<ChequesFilter>(
      TABLE_FILTER_SUPP
    );
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.nationalCode = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueSayadNumber = (childValues: any) => {
    const selectedItem = "";
    setValueSayadNumber(selectedItem);
    const tabelFilter = queryClient.getQueryData<ChequesFilter>(
      TABLE_FILTER_SUPP
    );
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.sayadNumber = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueCustomerMobileNumber = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerMobileNumber(selectedItem);
    const tabelFilter = queryClient.getQueryData<ChequesFilter>(
      TABLE_FILTER_SUPP
    );
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.cellPhone = undefined;
    fillData(tabelFilter!);
  };
  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  let exportExcel = () => {
    ExportChequeInfoMutation.mutate(
      valueFilterData ? valueFilterData! : ({} as ChequesFilter)
    );
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<ChequesFilter>(
      TABLE_FILTER_SUPP
    );
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };
  function changeValueSupplierIds(e: any, value: any) {
    setValueSupplierIds(e);
    setValueSupplier(value);
  }
  function changeValueLoanTemplateOptions(e: any, value: any) {
    setValueLoanTemplateOptions(e);
    setValueLoanTemplate(value);
  }
  function changeValuefinancialSupplierIds(e: any, value: any) {
    setValuefinancialSupplierIds(e);
    setValuefinancialSupplier(value);
  }
  function changeMultiSelectChip(e: any, value: any) {
    setValueMultiSelect(e.target.value);
    setValueMulti(value.props.children);
  }
  function changeValueDueDate(e: any) {
    setValueDueDate(e ? e.toString().replace(/,/g, " - ") : "");
    setDueDate(e);
  }
  function changeValueSayadNumber(e: any) {
    setValueSayadNumber(e.currentTarget.value);
  }
  function changeValueCustomerMobileNumber(e: any) {
    setValueCustomerMobileNumber(e.currentTarget.value);
  }
  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget.value);
  }
  function changeValuecustomerFullName(e: any) {
    setvaluecustomerFullName(e.currentTarget.value);
  }

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
  };
  function deleteChip() {
    setValueMultiSelect("");
    setValueMulti("");
    setValueLoanTemplateOptions([]);
    setValuefinancialSupplierIds([]);
    setValueLoanTemplate([]);
    setValuefinancialSupplier([]);
    setValueSupplierIds([]);
    setValueSupplier([]);
    setvaluecustomerFullName("");
    setValueSayadNumber("");
    setValueCustomerNationalCode("");
    setValueCustomerMobileNumber("");
    setValueRequestDate("");
    setDueDate([]);
    let chequesFilter = {} as ChequesFilter;
    queryClient.setQueryData(TABLE_FILTER_SUPP, chequesFilter);
    fillData(queryClient.getQueryData(TABLE_FILTER_SUPP)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = {} as ChequesFilter;
  filter.chequeType = "";
  filter.supplierIds = [];
  filter.loanTemplateIds = [];
  const lessFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropUpIcon style={{ color: "#1D4A87" }} />
      فیلترهای کمتر{" "}
    </span>
  );
  const extraFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropDownIcon style={{ color: "#1D4A87" }} />
      فیلترهای بیشتر
    </span>
  );
  return (
    <div>
      <Tooltip title='فیلتر' arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src='images/filter.png'
        />
      </Tooltip>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title='خروجی اکسل' arrow>
        <img
          onClick={exportExcel}
          className='cursorPointer'
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src='images/ExportXLS.svg'
        />
      </Tooltip>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values) => {
              if (
                dueDate != null &&
                (dueDate[0] != undefined || dueDate[1] != undefined)
              ) {
                values.dueDateFrom = convertToLocalDateTime(Number(dueDate[0]));
                if (dueDate.length > 1) {
                  values.dueDateTo = convertToLocalDateTime(Number(dueDate[1]));
                } else {
                  values.dueDateTo = convertToLocalDateTime(Number(dueDate[0]));
                }
              } else {
                values.dueDateFrom = undefined;
                values.dueDateTo = undefined;
              }
              values.supplierIds =
                valueSupplierIds.length === 0 ? undefined : valueSupplierIds;
              values.loanTemplateIds =
                valueLoanTemplateOptions.length === 0
                  ? undefined
                  : valueLoanTemplateOptions;
              values.financialSupplierIds =
                valuefinancialSupplierIds.length === 0
                  ? undefined
                  : valuefinancialSupplierIds;
              values.chequeType =
                valueMultiSelect === "" ? undefined : valueMultiSelect;
              values.customerFullName = valuecustomerFullName;
              values.nationalCode = valueCustomerNationalCode;
              values.cellPhone = valueCustomerMobileNumber;
              values.sayadNumber = valueSayadNumber;
              queryClient.setQueryData<ChequesFilter>(
                TABLE_FILTER_SUPP,
                values
              );
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      helperText={""}
                      placeHolder={"نام و نام خانوادگی متقاضی"}
                      label={"نام و نام خانوادگی متقاضی"}
                      required={false}
                      value={valuecustomerFullName}
                      onChange={changeValuecustomerFullName}
                      name='customerFullName'
                      id='customerFullName'
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"کد ملی"}
                      label={"کد ملی "}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name='nationalCode'
                      id='nationalCode'
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"شماره همراه"}
                      label={"شماره همراه"}
                      required={false}
                      value={valueCustomerMobileNumber}
                      onChange={changeValueCustomerMobileNumber}
                      name='cellPhone'
                      id='cellPhone'
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div>
                          <Autocomplate
                            id='supplierIds'
                            name='supplierIds'
                            value={valueSupplierIds}
                            label='پذیرنده'
                            options={supplierIdsOptions}
                            onChange={changeValueSupplierIds}
                            changeMultiSelect={changeValueSupplierIds}
                            responseValue={valueSupplier}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir='rtl'>
                          <Autocomplate
                            id='loanTemplateIds'
                            name='loanTemplateIds'
                            value={valueLoanTemplateOptions}
                            label='طرح تسهیلات'
                            options={loanTemplateOptions}
                            onChange={changeValueLoanTemplateOptions}
                            changeMultiSelect={changeValueLoanTemplateOptions}
                            responseValue={valueLoanTemplate}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <FormControl fullWidth className='shadowDatepicker'>
                      <DatePickerComponents
                        valueArray={dueDate}
                        label={" تاریخ چک "}
                        onChange={changeValueDueDate}
                        range={true}
                      />
                    </FormControl>
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      className='shadowTextField'
                      helperText={""}
                      placeHolder={"1234567890123456"}
                      label={"شماره صیادی"}
                      required={false}
                      value={valueSayadNumber}
                      onChange={changeValueSayadNumber}
                      name='sayadNumber'
                      id='sayadNumber'
                      inputProps={{ maxLength: 16 }}
                      type='tel'
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir='rtl' className='chequeType-dropdown'>
                          <DropdownCmp2
                            id='chequeTypeTitle'
                            name='chequeTypeTitle'
                            value={valueMultiSelect}
                            label='نوع چک'
                            options={chequeType}
                            onChange={changeMultiSelectChip}
                            // changeMultiSelect={changeMultiSelectChip}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter'
                    style={{ marginTop: "1vh" }}
                  >
                    <Button
                      fullWidth
                      variant='contained'
                      type='submit'
                      className='btnForm SuccessDefault  '
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>
                {valueMultiSelect?.length ||
                // valueSupplierSettlementStatus?.length ||
                valueLoanTemplateOptions?.length ||
                valuefinancialSupplierIds?.length ||
                // valueSupplierUserOptions?.length ||
                valueSupplierIds?.length ||
                // valuef ||
                valueSayadNumber ||
                valueCustomerNationalCode ||
                valuecustomerFullName ||
                valueCustomerMobileNumber ||
                valueDueDate ? (
                  //valueSettlementStatusDate
                  <div className='row tableCMP'>
                    <Grid container xs={12}>
                      <Grid item xs={12} sm={0.5}>
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src='images/RemoveAllFilters.svg'
                          />
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={11.5}
                        style={{ marginTop: "-9px" }}
                      >
                        <ChipCmp
                          item={valueMulti}
                          enamValue={valueMulti}
                          index={valueMulti?.length}
                          setChildValue={setChildValueStat}
                        />
                        <ChipCmp
                          item={valuefinancialSupplierIds}
                          enamValue={valuefinancialSupplierIds}
                          index={valuefinancialSupplierIds?.length}
                          setChildValue={setChildValuefinancialSupplier}
                        />
                        <ChipCmp
                          item={valueLoanTemplateOptions}
                          enamValue={loanTemplateOptions}
                          index={valueLoanTemplateOptions?.length}
                          setChildValue={setChildValueLoanTemplate}
                        />
                        <ChipCmp
                          item={valueSupplierIds}
                          enamValue={supplierIdsOptions}
                          index={valueSupplierIds?.length}
                          setChildValue={setChildValueSupplierIds}
                        />

                        <ChipCmp
                          item={valuecustomerFullName}
                          enamValue={valuecustomerFullName}
                          index={valuecustomerFullName?.length}
                          setChildValue={setChildValueCustomerFullName}
                        />
                        <ChipCmp
                          item={valueSayadNumber}
                          enamValue={valueSayadNumber}
                          index={valueSayadNumber?.length}
                          setChildValue={setChildValueSayadNumber}
                        />
                        <ChipCmp
                          item={valueCustomerNationalCode}
                          enamValue={valueCustomerNationalCode}
                          index={valueCustomerNationalCode?.length}
                          setChildValue={setChildValueCustomerNationalCode}
                        />
                        <ChipCmp
                          item={valueCustomerMobileNumber}
                          enamValue={valueCustomerMobileNumber}
                          index={valueCustomerMobileNumber?.length}
                          setChildValue={setChildValueCustomerMobileNumber}
                        />
                        <ChipCmp
                          item={valueDueDate}
                          enamValue={valueDueDate}
                          index={valueDueDate?.length}
                          setChildValue={setChildValueRequestDate}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />
      <div className='cardTableBorder'>
        <TableContainer
          style={{ background: "#fff", maxHeight: "55vh" }}
          className='boxScroll'
        >
          <Table
            stickyHeader
            aria-label='sticky table'
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className='rowTHead' style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                // selected={selectedRow === 0}
              >
                <TableCell
                  className='rowTHead colorTitle textFont12 fontWeight WidthRowNumber'
                  align='right'
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  #
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    className='rowTHead colorTitle textFont12 fontWeight noWrap'
                    key={column.id}
                    align='right'
                  >
                    {column.label}
                  </TableCell>
                ))}
                {/* <TableCell
                  className="rowTHead colorTitle stickyColO"
                  align="right"
                >
                 ***
                </TableCell> */}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data
                ? data.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role='checkbox'
                        tabIndex={-1}
                        key={rowIndex}
                        // selected={selectedRow === rowIndex}
                        onClick={() => {}}
                      >
                        <TableCell
                          className='textFont12 WidthRowNumber'
                          style={{ width: "10vh", minWidth: "10vh" }}
                        >
                          {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                            (currentPaginationInfo.pageSize! ?? 0) +
                            rowIndex +
                            1}
                        </TableCell>
                        {columns.map((column) => {
                          const value =
                            row[column.id as keyof GetChequeInfoReportResponse];
                          return (
                            <TableCell
                              className='textFont12'
                              key={column.id}
                              align='right'
                            >
                              {column.format && column.hasFormat
                                ? column.format(value)
                                : value?.toString()}
                            </TableCell>
                          );
                        })}
                        {/* <TableCell
                          className={
                            rowIndex % 2 == 0
                              ? " stickyColO   "
                              : " stickyColE  "
                          }
                        >
                        </TableCell> */}
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems='center'>
          <Grid
            item
            xs={12}
            sm={4}
            display='flex'
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display='flex' justifyContent='center'>
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={
                pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ChequeInfo;
